// @flow

import React from "react";
import {connect} from "react-redux";
import WelcomePage from "./WelcomePage/WelcomePage";
import RideRequest from "./RideRequest/RideRequest";
import Proposal from "./Proposal/Proposal";
import Ride from "./Ride/Ride";
import Screens from "../../Store/Views/screens";
import CurrentProposalSelectors from "../../Store/Ducks/CurrentProposal/selectors";
import BlockingError from "./BlockingError/BlockingError";
import TokenError from "./ExpiredToken/TokenError";

type ConnectedProps = {|
    showTechnicalIssue: boolean,
    showRide: boolean,
    showWelcomeScreen: boolean,
    showProposalScreen: boolean,
    showRideRequest: boolean,
    showTokenError: boolean,
    proposalID: number,
|};

const Screen = (props: ConnectedProps) => {

    /* ORDER MATTERS HERE */
    if (props.showTokenError) {
        return (<TokenError/>);
    }
    if (props.showTechnicalIssue) {
        return (<BlockingError/>);
    }
    if (props.showRide) {
        return (<Ride/>);
    }
    if (props.showWelcomeScreen) {
        return (<WelcomePage/>);
    }
    if (props.showProposalScreen) {
        return (<Proposal key={props.proposalID}/>);
    }
    if (props.showRideRequest) {
        return (<RideRequest style={{display: props.showWelcomeScreen ? `none` : `block`}}/>);
    }
    return null; //should be unreachable
};

const mapStateToProps = (state, props) => {
    return {
        showWelcomeScreen: Screens.shouldShowWelcomeScreen(state),
        showRideRequest: Screens.shouldShowRideRequest(state),
        showProposalScreen: Screens.shouldShowProposal(state),
        proposalID: CurrentProposalSelectors.getProposalID(state),
        showRide: Screens.shouldShowRide(state),
        showTechnicalIssue: Screens.shouldShowBlockingError(state),
        showTokenError: Screens.shouldShowTokenError(state),
    };
};

export default connect(mapStateToProps)(Screen);


// WEBPACK FOOTER //
// ./src/Components/Screen/Screen.js